import type { EditorPreviewCardEntry } from '@source-components-react/types';
import { ComponentIdentifiers } from '@source-components-react/component-identifiers';

export const previewCardEntry: EditorPreviewCardEntry = {
  id: ComponentIdentifiers.rText,
  // The classic typography "T" glyph used by most CMS text tools.
  icon: <span style={{ fontFamily: 'Georgia, serif', fontWeight: 'bold' }}>T</span>,
  label: 'Text',
};
